import { findAvailableLotMatch } from '../../utils/lotIdentity'
import { isLotActiveForInteraction } from '../../utils/lotInteraction'

type AvailableLot = {
  id: string
  lotKey: string
  stage?: string
}

export const resolvePreferredWaterLotId = (args: {
  lotId?: string | null
  lotKey?: string | null
  availableLots: AvailableLot[]
}): string => {
  const explicitLotId = String(args.lotId ?? '').trim()
  if (explicitLotId) {
    const exactLot = args.availableLots.find((lot) => String(lot.id ?? '').trim() === explicitLotId)
    if (exactLot) return isLotActiveForInteraction(exactLot.stage) ? exactLot.id : ''

    const resolvedLotFromId = findAvailableLotMatch(explicitLotId, args.availableLots)
    if (resolvedLotFromId.status === 'matched') {
      return isLotActiveForInteraction(resolvedLotFromId.match.stage) ? resolvedLotFromId.match.id : ''
    }
  }

  const explicitLotKey = String(args.lotKey ?? '').trim()
  if (!explicitLotKey) return ''

  const resolvedLotFromKey = findAvailableLotMatch(explicitLotKey, args.availableLots)
  if (resolvedLotFromKey.status !== 'matched') return ''

  return isLotActiveForInteraction(resolvedLotFromKey.match.stage) ? resolvedLotFromKey.match.id : ''
}